import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.every.js";
import "core-js/modules/esnext.iterator.some.js";
import { defineStore } from 'pinia';
import { debounce } from 'lodash-es';
import { useLocalStorage } from '@vueuse/core';
import { rafTimer } from '@utils/RafTimer';
import { getAccountInfo, assessResidualEquityNum, logoutAcc, getAuthInfoByAuth, listGeologyTree, getCurrentProduct, updateProductConfig, functionalRights } from './app.api';
export { storeToRefs } from 'pinia';
export default defineStore('app', () => {
  const loading = ref(true);
  const userInfo = ref(null); // 用户信息
  const equityData = ref(null); // 代运营提示词权益
  // 报告权益 内贸
  const assessEquityData = ref({
    accountId: '',
    count: 0,
    surplus: 0,
    purchase: 0
  });
  // 海外
  const ydylEquityData = ref({
    accountId: '',
    count: 0,
    surplus: 0,
    purchase: 0
  });
  const listGeology = ref(null); // 省市区
  const geoMode = useLocalStorage('geoMode', 'inner'); // 海外主题
  const rightConfig = ref(null); // 权益消耗配置
  const geoModeText = computed(() => {
    if (geoMode.value === 'outer') {
      return '海外';
    }
    return '内贸';
  });
  const isSpecAcc = computed(() => {
    const id = userInfo.value?.parentId || userInfo.value?.id;
    // 特殊账号判断  2156649 是测试环境yfbcsdyy004 2326496是线上lzx1@zdkajjfab
    return false;
  });
  const getRight = computed(() => {
    return (key, mode) => {
      if (loading.value || !rightConfig.value[key]) return 0;
      return rightConfig.value[key][mode || geoMode.value] ?? 0;
    };
  });
  // 根据权益id判断是否有权益
  const getRightsByIds = (ids, type = 'every') => {
    const obj = {
      603: equityData.value?.purchase,
      605: assessEquityData.value?.purchase,
      628: ydylEquityData.value?.purchase
    };
    if (type === 'every') {
      return ids.every(id => obj[id]);
    }
    return ids.some(id => obj[id]);
  };
  const surplusNum = computed(() => {
    if (geoMode.value === 'inner') {
      return assessEquityData.value?.surplus || 0;
    }
    return ydylEquityData.value?.surplus || 0;
  });
  const showAuthenticationDialog = ref(false);
  function setUserInfo() {
    loading.value = true;
    getAccountInfo().then(resp => {
      userInfo.value = resp?.data || null;
      loading.value = false;
      getAuthInfoByAuth().then(res => {
        if (res.data != null) {
          if (res.data.authStatus !== 1) {
            showAuthenticationDialog.value = true;
          }
        } else {
          showAuthenticationDialog.value = true;
        }
      });
    }).finally(() => {
      loading.value = false;
    });
  }
  // 评估剩余额度
  async function getAssessResidualEquityNum() {
    const {
      data
    } = await assessResidualEquityNum();
    if (data?.[603]) {
      // eslint-disable-next-line prefer-destructuring
      equityData.value = data[603];
      if (equityData.value?.surplus < 0) {
        equityData.value.surplus = 0;
      }
    }
    if (data?.[605]) {
      // eslint-disable-next-line prefer-destructuring
      assessEquityData.value = data[605];
      if (assessEquityData.value?.surplus < 0) {
        assessEquityData.value.surplus = 0;
      }
    }
    if (data?.[628]) {
      // eslint-disable-next-line prefer-destructuring
      ydylEquityData.value = data[628];
      if (ydylEquityData.value?.surplus < 0) {
        ydylEquityData.value.surplus = 0;
      }
    }
  }
  // 退出登录
  function logout() {
    logoutAcc().then(() => {
      window.location.href = `${process.env.VUE_APP_CONSOLE_LOGIN}?backUrl=${encodeURI(window.location.href)}`;
    });
  }
  // 获取省市区
  async function getListGeologyTree() {
    if (listGeology.value) return listGeology.value;
    const {
      data
    } = await listGeologyTree();
    listGeology.value = data;
    return data;
  }
  const injectionMonitor = () => {
    if (document.querySelector('.xtoken-monitor')) return;
    const script = document.createElement('script');
    script.className = 'xtoken-monitor';
    script.src = `${process.env.VUE_APP_NAV_TOP_URL}/xtoken-monitor.js`;
    document.head.appendChild(script);
  };
  // 防抖更新产品配置
  const debounceUpdateProductConfig = debounce(updateProductConfig, 500);
  // 更新html主题
  function updateHtmlTheme() {
    const htmlEl = document.documentElement;
    if (geoMode.value === 'outer') {
      htmlEl.classList.add('theme-outer');
    } else {
      htmlEl.classList.remove('theme-outer');
    }
  }
  // 设置海外主题
  function setGeoMode(mode, bol = true) {
    if (geoMode.value === mode) return;
    geoMode.value = mode;
    if (bol) debounceUpdateProductConfig({
      productId: geoMode.value === 'outer' ? 628 : 605
    });
  }
  const getCurrentGeoMode = async () => {
    try {
      const isInner = window.location.href.includes('mode=inner');
      const isOuter = window.location.href.includes('mode=outer');
      if (isInner) {
        geoMode.value = 'inner';
        debounceUpdateProductConfig({
          productId: 605
        });
        return;
      }
      if (isOuter) {
        geoMode.value = 'outer';
        debounceUpdateProductConfig({
          productId: 628
        });
        return;
      }
      const {
        data
      } = await getCurrentProduct();
      if (!data.productId) {
        const url = `${window.location.origin}/ydyl`;
        setGeoMode(window.location.href.includes(url) ? 'outer' : 'inner', false);
        debounceUpdateProductConfig({
          productId: geoMode.value === 'outer' ? 628 : 605
        });
        return;
      }
      const mode = data.productId === 628 ? 'outer' : 'inner';
      setGeoMode(mode);
    } catch (error) {
      setGeoMode('inner');
    } finally {
      loading.value = false;
    }
  };
  const getFunctionalRights = async () => {
    try {
      const {
        data
      } = await functionalRights();
      rightConfig.value = data;
    } catch (error) {
      console.log(error);
    }
  };
  async function init() {
    getFunctionalRights();
    getCurrentGeoMode();
    setUserInfo();
    injectionMonitor();
    await Promise.all([getAssessResidualEquityNum()]);
    rafTimer.addTask({
      key: 'getAssessResidualEquityNum',
      interval: 1000 * 60 * 5,
      callback: getAssessResidualEquityNum
    });
  }
  watch(geoMode, updateHtmlTheme, {
    immediate: true
  });
  return {
    loading,
    userInfo,
    isSpecAcc,
    getRight,
    equityData,
    listGeology,
    getRightsByIds,
    assessEquityData,
    ydylEquityData,
    surplusNum,
    setUserInfo,
    getAssessResidualEquityNum,
    logout,
    init,
    showAuthenticationDialog,
    getListGeologyTree,
    geoMode,
    geoModeText,
    setGeoMode
  };
});